import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from "../store"

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    dark: store.state.currentTheme == "dark"? true :false,
    themes: {
      light: {
        accent: '#FFC123',
        // Button colors
        selectedNav: '#FFFFFF',  // Add this line
        buttonPrimary: '#28EA96',
        buttonHover: '#C3FFE3',
        buttonDisabled: '#C3FFE3',
        buttonText: '#005931',
        buttonTextDisabled: '#9A9A9A',
        buttonTextPressed: '#F8F8F8',
        
        // Secondary Button Colors
        buttonSecondary: '#EEEEEE',
        buttonSecondaryHover: '#9A9A9A',
        buttonSecondaryPressed: '#9A9A9A',
        buttonSecondaryDisabled: '#EEEEEE',
        buttonSecondaryText: '#14161B',
        buttonSecondaryTextHover: '#F8F8F8',
        buttonSecondaryTextDisabled: '#9A9A9A',
        cardBackground: '#FFFFFF',

        // Links
        link: '#005931',
        
        // Other brand colors you might need
        brandGreen: '#28EA96',
        calmGreen: '#C3FFE3',
        mainGreen: '#28EA96',
        primary: '#28EA96',
        black: '#14161B',
        white: '#f2f2f2',
        mainBlack: '#14161B',
        mainWhite: '#f2f2f2',
        lightGray: '#EBEBEB',
        mediumGray: '#ABABAB',
        darkGray: '#3B3B3B',
        darkGreen: '#005931',
        darkRed: '#D00808',
        blue: '#2196F3',
        accentYellow: '#F9E65F',
      },
      dark: {
        // Button colors (you can adjust for dark theme)
        accent: '#F9E65F',
        selectedNav: '#FFFFFF',  // Add this line
        buttonPrimary: '#28EA96',
        buttonHover: '#C3FFE3',
        buttonDisabled: '#C3FFE3',
        buttonText: '#005931',
        buttonTextDisabled: '#9A9A9A',
        
        // Secondary Button Colors (same as light for consistency)
        buttonSecondary: '#303740',
        buttonSecondaryHover: '#4E5966',
        buttonSecondaryPressed: '#4E5966',
        buttonSecondaryDisabled: '#303740',
        buttonSecondaryText: '#F8F8F8',
        buttonSecondaryTextHover: '#F8F8F8',
        buttonSecondaryTextDisabled: '#4E5966',

        // Links
        link: '#28EA96',
        
        // Other brand colors for dark theme
        brandGreen: '#28EA96',
        calmGreen: '#C3FFE3',
        mainGreen: '#28EA96',
        cardBackground: '#232830',
        primary: '#28EA96',
        black: '#14161B',
        white: '#f3f3f3',
        lightGray: '#303740',
        mediumGray: '#4E5966',
        darkGray: '#CDDAEB',
        mainBlack: '#f2f2f2',
        mainWhite: '#14161B',
        darkGreen: '#005931',
        darkRed: '#EB5050',
        blue: '#2196F3',
        accentYellow: '#FFC123',
      },
    },
    options: { customProperties: true },
  },
});
